module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mt-table"
  }, [_c('table', {
    attrs: {
      "border": _vm.tableOption.tableBorder,
      "cellspacing": _vm.tableOption.tableCellspacing
    }
  }, [(_vm.computedColumnOptions) ? _c('colgroup', _vm._l((_vm.computedColumnOptions), function(header, index) {
    return _c('col', {
      key: ("col-index-" + index),
      class: ("mt-table_column_" + index),
      attrs: {
        "width": header['min-width']
      }
    })
  })) : _vm._e(), _vm._v(" "), (_vm.computedColumnOptions) ? _c('thead', [_c('tr', _vm._l((_vm.computedColumnOptions), function(header, index) {
    return _c('th', {
      key: ("header-" + index),
      staticClass: "header",
      attrs: {
        "data-selector": "header-column"
      }
    }, [(typeof _vm.renderHeader === 'function') ? _c('column', {
      key: ("header-" + index),
      attrs: {
        "column": header,
        "renderColumn": _vm.renderHeader,
        "data-selector": "body-column"
      }
    }) : _c('div', {
      staticClass: "cell"
    }, [_c('div', {
      staticClass: "column"
    }, [_c('p', [_vm._v(_vm._s(header.label))])])])], 1)
  }))]) : _vm._e(), _vm._v(" "), _c('tbody', _vm._l((_vm.tableData), function(row, rowIndex) {
    return _c('tr', {
      key: ("row-" + rowIndex)
    }, [_vm._l((_vm.headerArray), function(column, colIndex) {
      return [_c('td', {
        key: ("column-" + colIndex),
        attrs: {
          "data-selector": "body-column"
        }
      }, [(typeof _vm.renderColumn === 'function') ? _c('column', {
        key: ("column-" + colIndex),
        attrs: {
          "column": column,
          "renderColumn": _vm.renderColumn,
          "data-selector": "body-column"
        }
      }) : _c('div', {
        staticClass: "cell"
      }, [_vm._v(_vm._s(_vm.setRenderColumn(row, column)))])], 1)]
    })], 2)
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c07ce2e","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/plugins/mtui/table/Table.vue
// module id = hIjc
// module chunks = 0